export default "__VITE_ASSET__2hMszC84__"